module.exports = __webpack_public_path__ + "rw.a15eafd84ea9d2bf6eaa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/rw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/rw.svg
// module chunks = styles